import * as React from 'react'
import { ReactElement, useContext, useEffect } from 'react'
import TimeReportForm from '../../components/Form/Finance/Report/TimeReportForm'
import TierReportForm from '../../components/Form/Finance/Report/TierReportForm'
import InvoiceReportForm from '../../components/Form/Finance/Report/InvoiceReportForm'
import FilesPerUserReportForm from '../../components/Form/Finance/Report/FilesPerUserReportForm'
import BilledTurnoverReportForm from '../../components/Form/Finance/Report/BilledTurnoverReportForm'
import OngoingFilesReportForm from '../../components/Form/Finance/Report/OngoingFilesReportForm'
import OutstandingInvoicesForm from '../../components/Form/Finance/Report/OutstandingInvoicesForm'
import UserProductivityForm from '../../components/Form/Finance/Report/UserProductivityReportForm'
import WipReportForm from '../../components/Form/Finance/Report/WipReportForm'
import PartyCardReportForm from '../../components/Form/Finance/Report/PartyCardReportForm'
import useModules from '../../hooks/module/useModules'
import { ModuleType } from '../../context/GlobalContext'
import { AppAction } from '../../config/appConfig'
import { MenuItemKey } from '../../components/MainMenu'
import { useDispatch } from 'react-redux'
import FixedPricesReportForm from '../../components/Form/Finance/Report/FixedPricesReportForm'
import { makeStyles, tokens } from '@fluentui/react-components'
import TurnoverDashboardReportForm from '../../components/Form/Finance/Report/TurnoverDashboardReportForm'
import FileClaimListReportForm from '../../components/Form/Finance/Report/FileClaimListReportForm'
import { FileAction } from '../../config/fileConfig'
import AuthorizationContext from '../../context/AuthorizationContext'

const useStyles = makeStyles({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: tokens.spacingHorizontalM,
    },
})

export type ReportFormType = {
    orientation: 'horizontal' | 'vertical'
}

export default function Reports(): ReactElement {
    const { host: currentHost } = useContext(AuthorizationContext)
    const dispatch = useDispatch()
    const modules = useModules()
    const styles = useStyles()

    const orientation = 'vertical'

    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Reports] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [])

    return (
        <div className={styles.container}>
            <TimeReportForm orientation={orientation} />
            <OutstandingInvoicesForm orientation={orientation} />
            <BilledTurnoverReportForm orientation={orientation} />
            <UserProductivityForm orientation={orientation} />
            {modules.has(ModuleType.WorkInProgress) && <WipReportForm orientation={orientation} />}
            <OngoingFilesReportForm orientation={orientation} />
            <InvoiceReportForm orientation={orientation} />
            <TierReportForm orientation={orientation} />
            <FilesPerUserReportForm orientation={orientation} />
            <FixedPricesReportForm orientation={orientation} />
            <PartyCardReportForm orientation={orientation} />
            {modules.has(ModuleType.ReportsPro) && <TurnoverDashboardReportForm orientation={orientation} />}
            {['bdo-cls', 'dev', 'test'].includes(currentHost?.RowKey) && <FileClaimListReportForm orientation={orientation} />}
        </div>
    )
}
